import React from "react";
import Logo from "./Logo";
import { Phone, Mail } from "lucide-react";

const scrollTo = (href) => {
  const el = document.querySelector(href);
  if (el) window.__lenis ? window.__lenis.scrollTo(el, { offset: -80 }) : el.scrollIntoView({ behavior: "smooth" });
};

export const Footer = () => (
  <footer data-testid="site-footer" className="relative bg-[#08070e] text-slate-400 pt-16 pb-10 overflow-hidden grain">
    <div className="absolute -bottom-24 left-1/2 -translate-x-1/2 w-[40rem] h-[40rem] rounded-full opacity-20" style={{ background: "radial-gradient(circle,#E933C6,transparent 65%)", filter: "blur(90px)" }} />
    <div className="relative z-10 max-w-7xl mx-auto px-5 sm:px-8">
      <div className="grid md:grid-cols-3 gap-10 pb-12 border-b border-white/10">
        <div>
          <Logo variant="dark" />
          <p className="mt-5 max-w-xs text-sm leading-relaxed">
            AI consulting for growing organizations. Strategy, tools, and training — built around how
            you actually work.
          </p>
        </div>
        <div>
          <div className="font-mono-accent text-[10px] tracking-[0.2em] uppercase text-fuchsia-400 mb-4">Explore</div>
          <ul className="space-y-2.5 text-sm">
            {[["Services", "#services"], ["Conscientious AI", "#manifesto"], ["Founder", "#founder"], ["See It in Action", "#casestudy"], ["Book a Call", "#contact"]].map(([l, h]) => (
              <li key={h}>
                <button onClick={() => scrollTo(h)} className="hover:text-fuchsia-300 transition-colors">{l}</button>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <div className="font-mono-accent text-[10px] tracking-[0.2em] uppercase text-fuchsia-400 mb-4">Get in touch</div>
          <a href="tel:8437315155" className="flex items-center gap-2.5 text-sm hover:text-fuchsia-300 transition-colors mb-3">
            <Phone size={16} /> 843-731-5155
          </a>
          <a href="mailto:info@activatethenelevate.com" className="flex items-center gap-2.5 text-sm hover:text-fuchsia-300 transition-colors">
            <Mail size={16} /> info@activatethenelevate.com
          </a>
        </div>
      </div>
      <div className="pt-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-slate-500">
        <span>© {new Date().getFullYear()} Activate Then Elevate. All rights reserved.</span>
        <span className="font-mono-accent tracking-wide">AI Consultant Certification in progress · backed by a Ph.D. in Curriculum &amp; Instruction</span>
      </div>
    </div>
  </footer>
);

export default Footer;
